import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { ui } from "./tokens";

/**
 * FormPage
 * - Card full width (según ui.card)
 * - Contenido centrado con maxWidth
 * - Header con título y botón Volver
 * - Slot de acciones pegado al contenido
 */
export default function FormPage({
  title,
  onBack,
  right,
  children,
  actions,
  sx,
  contentSx,
  contentMaxWidth = 960,   // 👈 controla qué tan “angosto” ves el formulario
}) {
  return (
    <Box sx={{ p: 3 }}>
      <Card sx={{ ...ui.card, ...(sx || {}) }}>
        {/* Header */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          px={3}
          pt={2}
          pb={2}
        >
          <Typography variant="h6" fontWeight={800} color="text.primary">
            {title}
          </Typography>

          {right ?? (
            onBack && (
              <Button variant="outlined" onClick={onBack} sx={ui.btnOutline}>
                Volver
              </Button>
            )
          )}
        </Box>

        {/* Contenido centrado */}
        <Box
          px={3}
          pb={2}
          sx={{ maxWidth: contentMaxWidth, mx: "auto", width: "100%", ...(contentSx || {}) }}
        >
          {children}
        </Box>

        {/* Acciones centradas bajo el contenido */}
        {actions && (
          <Box
            px={3}
            pb={3}
            display="flex"
            gap={1}
            sx={{ maxWidth: contentMaxWidth, mx: "auto", width: "100%" }}
          >
            {actions}
          </Box>
        )}
      </Card>
    </Box>
  );
}